import type { TaskHistoryCategory } from '../../types/taskHistory';

/** Централизованная палитра категорий задач (Ant Design Tag color tokens). */
export const TASK_CATEGORY_COLORS: Record<TaskHistoryCategory, string> = {
  DOCUMENTS: 'blue',
  PHOTO: 'purple',
  FINANCE: 'gold',
  CONTROL: 'cyan',
  CLIENT: 'geekblue',
  CARRIER: 'volcano',
  PENALTY: 'red',
  OTHER: 'default'
};
